module.exports = "<wow-header-skip-links></wow-header-skip-links>\r\n<wow-corporate-header class=\"hidden-xs\" class-modifier=\"corporateHeader--horizontal\"></wow-corporate-header>\r\n<wow-core-header></wow-core-header>\r\n<wow-category-header ng-if=\"!$ctrl.$breakpoints.isInDropDownMenuFormat\" class-modifier=\"categoryHeader--horizontal\"></wow-category-header>\r\n<wow-category-header-small-format ng-if=\"$ctrl.$breakpoints.isInDropDownMenuFormat \"></wow-category-header-small-format>\r\n<wow-small-menu ng-if=\"$ctrl.$breakpoints.isInDropDownMenuFormat\"></wow-small-menu>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/header/header.component.html
// module id = 177
// module chunks = 0 2